"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTermSanitiser = void 0;
const searchTermSanitiser = (value) => {
    if (!value)
        return "";
    return value.replace(/[^a-zA-Z0-9 ]/g, "");
};
exports.searchTermSanitiser = searchTermSanitiser;
//# sourceMappingURL=sanitisation.js.map